/**
 * Merge a list request into the stored query of a slice that several tabs
 * share (the professional roles, parent vs shelter pets — DAB-880).
 *
 * Arriving with a different `scopeKey` value (another role tab) starts from
 * page 1 with no search term instead of inheriting the last tab's; staying on
 * the same tab keeps both. Anything the payload sets explicitly still wins.
 */
export const mergeListQuery = (storedQuery, payload, scopeKey) => {
  const isNewScope = payload?.[scopeKey] !== undefined && payload[scopeKey] !== storedQuery?.[scopeKey];
  return { ...storedQuery, ...(isNewScope && { q: "", page: 1 }), ...payload };
};
